import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingReportCriterion } from '@euler/model/coaching-practice';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors, tint } from '../../../../ai-suite/theme';
import { Chip } from '../../../components/Chip';
import { kAnchorColors, kAnchorLabels } from '../../practiceCopy';
import { ReportSection } from './ReportSection';

/** A drill's one criterion: how it went, the line, and a better one. */
export const DrillVerdict = memo(
  ({
    criterion,
    betterLine,
  }: {
    criterion: CoachingReportCriterion | null;
    betterLine: string | null;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <ReportSection title="这一段">
        {criterion ? (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'flex-start',
              gap: rpx(8),
            }}
          >
            <View style={{ flex: 1, minWidth: 0, gap: rpx(4) }}>
              <Typography.Text size={rpx(14)} bold color={aiColors.foreground}>
                {criterion.name}
              </Typography.Text>
              {criterion.citedLine ? (
                <Typography.Text
                  size={rpx(12)}
                  color={aiColors.mutedForeground}
                >
                  {`你说：“${criterion.citedLine}”`}
                </Typography.Text>
              ) : null}
            </View>
            <Chip
              text={kAnchorLabels[criterion.anchor]}
              color={kAnchorColors[criterion.anchor]}
            />
          </View>
        ) : null}
        {betterLine ? (
          <View
            style={{
              borderRadius: rpx(12),
              backgroundColor: tint(aiColors.accent, 0.6),
              padding: rpx(10),
              gap: rpx(2),
            }}
          >
            <Typography.Text
              size={rpx(11)}
              bold
              color={aiColors.accentForeground}
            >
              可以这样说
            </Typography.Text>
            <Typography.Text
              size={rpx(12)}
              color={aiColors.foreground}
              style={{ lineHeight: rpx(18) }}
            >
              {betterLine}
            </Typography.Text>
          </View>
        ) : null}
      </ReportSection>
    );
  },
);
